/**
 * Função sem efeito que ignora quaisquer argumentos e retorna `undefined`,
 * substituindo o `noop` do lodash por implementação nativa.
 */
export const noop = (..._args: any[]): undefined => undefined

/**
 * Retorna o próprio argumento recebido, substituindo o `identity` do lodash
 * por implementação nativa.
 */
export const identity = <T>(value: T): T => value
